<template>
  <div class="site-box">
    <list-block>
      <list-filter
        :form="form"
        @searchData="onSearch"
        @resetData="resetData"
      />
    </list-block>
    <list-block>
      <div class="create-btn">
        <el-button
          v-auth="[$_buttonPermission.PLATFORM_SITEMANAGEMENT_OPERATION]"
          type="primary"
          @click="addNewSite()"
        >
          新增站点
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        class="index-call"
        border
        highlight-current-row
      >
        <el-table-column
          v-for="item in fields"
          :key="item.props"
          :prop="item.isComponent? '' :item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed"
          :min-width="item.minWidth"
        >
          <template
            v-if="item.isComponent"
            #default="scope"
          >
            <Operation
              :row="scope.row"
              @bound="openBoundSite"
              @add="openSite"
              @detail="openDetails"
            />
          </template>
        </el-table-column>
      </el-table>
      <pagination
        ref="SitePagination"
        :total="total"
        :current-page.sync="page"
        @search="fetchData"
      />
    </list-block>
    <el-dialog
      v-if="addSite"
      :title="Viewstate?'查看详情':'新增/编辑'"
      :visible.sync="addSite"
      width="1200px"
      :close-on-click-modal="false"
    >
      <div style="width:100%;height:100%">
        <PopUp
          @save="requstSaveData"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addSite = false">取 消</el-button>
        <el-button
          v-show="!Viewstate"
          type="primary"
          @click="saveSite()"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="绑定站点"
      class="bound-site"
      :visible.sync="boundSite"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <el-form
          label-position="right"
          label-width="100px"
          :model="bindData"
        >
          <el-form-item label="租户名称:">
            <el-select
              v-model="bindData.tenantName"
              filterable
              remote
              reserve-keyword
              :disabled="bindData.tenantName?true:false"
              placeholder="请输入租客名称"
              :remote-method="remoteMethod"
              :loading="load"
              @change="valChange"
            >
              <el-option
                v-for="item in restaurants"
                :key="item.tenantId"
                :label="item.tenantName"
                :value="item.tenantId"
                class="bind-input"
              >
                <span>{{ item.tenantName }}</span>
                <span class="tenantId">({{ item.tenantId }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户名称:">
            <el-select
              v-model="bindData.customerName"
              filterable
              remote
              reserve-keyword
              placeholder="请输入客户名称"
              :remote-method="remoteMethod1"
              :loading="load"
            >
              <el-option
                v-for="item in restaurants1"
                :key="item.id"
                :label="item.customerName"
                :value="item.customerName"
                class="bind-input"
              >
                <span>{{ item.customerName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户站点编码:">
            <el-input
              v-model="bindData.customerStationCode"
              class="bind-input"
              placeholder="请输入客户站点编码"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="boundSite = false">取 消</el-button>
        <el-button type="primary" @click="boundNewSite()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/Pagination/index.vue';
import ListBlock from '@/components/ListBlock/index.vue';
import {
  upSiteInfo, getSitePage, getSiteBind, gettenantName, getcustomerName,
} from '@/api/siteManagement';
import {
  fields, SiteTypesInfo, SiteStatus, SiteCommercialtype,
} from './const';
import PopUp from './components/popUp.vue';
import Bus from './bus';
import Operation from './components/operation.vue';
import ListFilter from './components/ListFilter.vue';

export default {
  name: 'SiteManagement',
  components: {
    ListBlock,
    PopUp,
    pagination,
    Operation,
    ListFilter,
  },
  data() {
    return {
      loading: false,
      total: null,
      fields,
      optionData: null,
      addSite: false,
      form: {},
      tableData: [],
      editRow: null,
      Viewstate: false,
      boundSite: false,
      bindData: {
        customerStationCode: '', // 客户站点编码
        tenantName: '', // 租户名称
        tenantId: '', // 租户ID
        customerId: '', // 货主ID
        customerCode: '', // 货主编号
        customerName: '', // 货主名称
        stationId: '', // 站点ID
      },
      restaurants: [],
      load: false,
      restaurants1: [],
      page: 1,
    };
  },
  computed: {
  },
  async created() {
    this.fetchData(1, 10);
  },
  methods: {
    onSearch() {
      this.currentPage = 1;
      this.fetchData(1, 10);
    },
    resetData() {
      this.form = {};
      this.fetchData(1, 10);
    },
    timeSort(val) {
      val.sort((a, b) => Date.parse(b.createTime) - Date.parse(a.createTime));
      return val;
    },
    valChange(val) {
      this.bindData.tenantId = val;
    },
    valChange1(val) {
      this.bindData.customerCode = val;
      const res = this.restaurants1.filter((v) => v.customerCode === val)[0];
      this.bindData.customerId = res.id;
      this.fromData.customerName = res.customerName;
    },
    remoteMethod(query) {
      this.restaurants = [];
      if (query !== '') {
        this.load = true;
        gettenantName({ tenantName: query }).then((res) => {
          this.load = false;
          this.restaurants = res.records;
        });
      } else {
        this.restaurants = [];
      }
    },
    remoteMethod1(query) {
      this.restaurants1 = [];
      if (query !== '') {
        this.load = true;
        getcustomerName({ customerName: query, ownerTenantId: this.bindData.tenantId }).then((res) => {
          this.load = false;
          this.restaurants1 = res.records;
          this.bindData.customerCode = res.records.customerCode;
          this.bindData.customerId = res.records.id;
        });
      } else {
        this.restaurants1 = [];
      }
    },
    requstSaveData(e) {
      // 新增字段changedChannel值为PLATFORM_STATION_MANAGE
      e.changedChannel = 'PLATFORM_STATION_MANAGE';
      upSiteInfo(e).then(() => {
        this.addSite = false;
        this.fetchData(1, 10);
        this.$message.success('保存成功!');
      }).catch(() => {
      });
    },
    // 翻页
    async fetchData(page, size) {
      this.loading = true;
      try {
        const params = { page, size };
        const res = await getSitePage(this.form, params);
        const data = res.records.map((v) => ({
          ...v,
          bizType: SiteTypesInfo[v.bizType],
          type: SiteCommercialtype[v.type],
          positionInfo: v.provinceName + v.cityName + v.countyName,
          status: SiteStatus[v.status],
          createTime: this.timestampToTime(v.createTime),
        }));
        this.total = res.total;
        this.tableData = this.timeSort(data);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    // 新增编辑保存按钮
    saveSite() {
      Bus.$emit('flag', this.addSite);
      // 发送数据保存的请求
    },
    // 站点绑定确认按钮
    async boundNewSite() {
      const res = await getSiteBind(this.bindData);
      if (res) {
        this.$message.success('绑定成功!');
        this.boundSite = false;
      } else {
        this.$message.error('绑定失败,请重新绑定!');
      }
      // 发送绑定站点的请求
      this.fetchData(1, 10);
    },

    addNewSite() {
      Bus.$emit('newAdd', false);
      this.addSite = true;
      this.Viewstate = false;
      setTimeout(() => {
        Bus.$emit('newState');
      }, 20);
    },
    openSite(e) {
      this.addSite = true;
      this.Viewstate = false;
      setTimeout(() => {
        Bus.$emit('examineState', e);
      }, 20);
    },
    openDetails(e) {
      // 详情
      this.addSite = false;
      this.Viewstate = true;
      this.addSite = true;
      setTimeout(() => {
        Bus.$emit('viewSiteDetail', e);
      }, 20);
    },
    openBoundSite(e) {
      const {
        id, tenantId, customerId, customerCode, tenantName, customerName, customerStationCode,
      } = e;
      const data = {
        customerStationCode, // 客户站点编码
        tenantName, // 租户名称
        tenantId, // 租户ID
        customerId, // 货主ID
        customerCode, // 货主编号
        customerName, // 货主名称
        stationId: id, // 站点ID
      };
      this.bindData = data;
      this.boundSite = true;
    },
    mathzero(num) {
      return num < 10 ? `0${num}` : num;
    },
    // 时间戳转YYYY-MM-DD hh:mm:ss
    timestampToTime(timestamp) {
      const d = new Date(timestamp);
      return `${d.getFullYear()}-${this.mathzero((d.getMonth() + 1))}-${this.mathzero(d.getDate())} ${this.mathzero(d.getHours())}:${this.mathzero(d.getMinutes())}:${this.mathzero(d.getSeconds())}`;
    },

  },
};
</script>

<style  scoped>
.site-box{
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.create-btn {
  margin-bottom: 12px;
  text-align: right;
}
.el-dialog__wrapper >>> .el-dialog__body{
  padding: 0 20px;
   height: 600px !important;
  overflow-y: scroll !important;
}
 .bound-site >>> .el-dialog__body{
   height: 200px !important;
   overflow: auto !important;
}
.dialog-content{
    padding-top: 20px;

}
.dialog-content label{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .dialog-text{
    width: 120px;
    text-align: right;
    margin-right: 10px;
  }
 .el-dialog__wrapper >>>.el-dialog__header{
    background: #fafafa !important;
  }
 .el-table >>> .cell{
    white-space: nowrap !important;
 }
::v-deep .el-form-item__content{
   display: flex !important;
 }

</style>
